module.exports = __webpack_public_path__ + "static/img/img23.d65594e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neighbourhood/img23.png
// module id = tmt3
// module chunks = 1